// angular imports
import { Component, EventEmitter, Injector, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

// cc-common imports
import { IconConstants, Utils } from 'cc-common';

// component imports
import { WorkOrderBaseComponent } from '../../_base/work-order-base-component';

// model imports
import { ClosedWorkOrderParameterDto } from '../../_models/closed-work-order-parameter-dto';
import { WorkOrderResultDto } from '../../_models/work-order-result-dto';

@Component({
    selector: 'app-closed-work-orders',
    templateUrl: './closed-work-orders.component.html',
    styleUrls: ['./closed-work-orders.component.scss']
})
export class ClosedWorkOrdersComponent extends WorkOrderBaseComponent implements OnChanges {
    @Input() communityId: number;
    @Input() isPopup = false;
    @Input() vendorId: number;
    @Input() workOrderIds: Array<number> = [];
    @Input() selectedWorkOrderId: number = null;
    @Input() customerId: string;
    @Input() workflowId: number = null;

    @Output() onWorkOrderSelection = new EventEmitter<number[]>();
    @Output() onWorkOrderDeselection = new EventEmitter<number[]>();

    closedWorkOrders: Array<WorkOrderResultDto> = [];
    numberOfDays = 90;

    iconRefresh = IconConstants.REFRESH;

    constructor(protected readonly injector: Injector) {
        super(injector);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (Utils.notNullAndDefined(changes.communityId) && Utils.notNullAndDefined(changes.communityId.currentValue)) {
            this.communityId = changes.communityId.currentValue;
        }
        this.populateClosedWorkOrders();
    }

    onNoOfDaysChange(e: any): void {
        if (Utils.notNullAndDefined(e.component)) {
            const value = e.component._parsedValue;
            const isValid = value > 0 && value <= 3650;
            e.component.option({
                validationStatus: isValid ? 'valid' : 'invalid',
                validationErrors: isValid ? [] : [{ message: `The number must be in the range 1...3650` }]
            });
        }
    }

    forceRefresh(): void {
        this.populateClosedWorkOrders(true);
    }

    onWorkOrderRecordsSelection(records: Array<number>): void {
        this.onWorkOrderSelection.emit(records);
    }

    onWorkOrderRecordsDeselection(records: Array<number>): void {
        this.onWorkOrderDeselection.emit(records);
    }

    private populateClosedWorkOrders(clearCache = false): void {
        const baseParams: ClosedWorkOrderParameterDto = new ClosedWorkOrderParameterDto();
        baseParams.communityId = this.communityId;
        baseParams.numberOfDays = this.numberOfDays;
        baseParams.customerId = this.customerId;
        baseParams.workflowId = this.workflowId;

        if (Utils.notNullAndDefined(this.vendorId)) {
            baseParams.managementCompanyVendorId = this.vendorId;
        }
        baseParams.clearCache = clearCache;

        this.workOrderHelperService.showLoading();
        this.workOrderService.getClosedWorkOrders(baseParams).subscribe(
            (workOrders: WorkOrderResultDto[]) => {
                this.closedWorkOrders = Utils.isNullOrUndefined(this.selectedWorkOrderId)
                    ? workOrders
                    : workOrders.filter((d) => Utils.equals(d.workOrderId, this.selectedWorkOrderId));

                this.workOrderHelperService.hideLoading();
            },
            (error) => {
                this.errorService.displayError(error);
                this.workOrderHelperService.hideLoading();
            }
        );
    }
}
